import { memo } from '@morphic-ts/common/es6/utils';
import { pipe } from 'fp-ts/function';
import { showApplyConfig } from '../config';
import { ShowType, ShowURI } from '../hkt';
/**
 *  @since 0.0.1
 */
export const showRefinedInterpreter = memo(() => ({
    _F: ShowURI,
    refined: (getShow, _ref, name, config) => env => pipe(getShow(env).show, show => new ShowType({ show: x => `<${name}>(${showApplyConfig(config)(show, env, { show }).show(x)})` })),
    constrained: (getShow, _ref, name, config) => env => pipe(getShow(env).show, show => new ShowType({ show: x => `<${name}>(${showApplyConfig(config)(show, env, { show }).show(x)})` }))
}));
